import { CSSProperties } from 'react';

export const SelectOptionStyle: CSSProperties = {
  height: 40,
  fontWeight: 100,
  display: 'flex',
  alignItems: 'center',
  marginBottom: 2,
};
